var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/remove"),React.createElement("g",{"id":"icon/remove","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"ic_remove_48px","transform":"translate(0.000000, 14.000000)","fill":"#1D1655","fillRule":"nonzero"},React.createElement("polygon",{"id":"Path","points":"32 4.57142857 0 4.57142857 0 0 32 0"})))]);
}

Remove.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = Remove;

Remove.default = Remove;
